import { render } from "./Or_tableClaim.vue?vue&type=template&id=c7420000&scoped=true&ts=true"
import script from "./Or_tableClaim.vue?vue&type=script&lang=ts"
export * from "./Or_tableClaim.vue?vue&type=script&lang=ts"

import "./Or_tableClaim.vue?vue&type=style&index=0&id=c7420000&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7420000"]])

export default __exports__